import { useEffect, useState } from "react";

import { Box, Grid, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { CheckBoxOutlined, WarningAmberOutlined } from "@mui/icons-material";

import userService from "../../../services/userService";
import { UserStatsDto } from "../../../interfaces/admin/UserStatsDto";
import { UserType } from "../../../common/interfaces/enums/UserType";
import CardBoxExtended from "../../../common/components/mui-extended/CardBoxExtended";

export default function Home() {
  const [userStats, setUserStats] = useState<Record<UserType, UserStatsDto>>();

  useEffect(() => {
    (async () => {
      await userService.getUserStatsByType().then(({ data: userStats }) => {
        setUserStats(userStats);
      });
    })();
  }, []);

  return (
    <Stack sx={{ pt: 3 }}>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={5}>
            <CardBoxExtended title="Активни потребители" titleColor="primary">
              <Table sx={{ mt: "10px", mb: "-15px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Нотариуси</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.Notary]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Помощник-нотариуси по заместване</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.NotaryDeputy]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Външни потребители</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.ExternalUser]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Потребители на АВ</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.RegistryAgencyUser]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Потребители на банка</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.BankUser]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Кметове</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.Mayor]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Инв. посредници</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.InvestmentBrokerUser]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Stack direction="row" spacing={1}>
                        <CheckBoxOutlined color="secondary" />
                        <Typography>Застрахователи</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Typography>
                        <strong>{userStats?.[UserType.InsurerUser]?.activeUsersCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardBoxExtended>
          </Grid>

          <Grid item xs={12} lg={7}>
            <CardBoxExtended title="Потребители без електронен подпис в системата" titleColor="primary">
              <Table sx={{ mt: "10px", mb: "-15px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Нотариуси</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.Notary]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Помощник-нотариуси по заместване</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.NotaryDeputy]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Външни потребители</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.ExternalUser]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Потребители на АВ</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.RegistryAgencyUser]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Потребители на банка</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.BankUser]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Инв. посредници</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{userStats?.[UserType.InvestmentBrokerUser]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Stack direction="row" spacing={1}>
                        <WarningAmberOutlined color="secondary" />
                        <Typography>Застрахователи</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Typography>
                        <strong>{userStats?.[UserType.InsurerUser]?.usersWithoutCertificateCount}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardBoxExtended>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}
